import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RedirectToDevicePortal = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('android')) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.sferion.hrbadvantagecard';
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
      window.location.href =
        'https://apps.apple.com/us/app/advantage-app/id6736556268';
    } else {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div>
      <p>Redirecting you to the appropriate store...</p>
    </div>
  );
};

export default RedirectToDevicePortal;
